import { IPendingEverifyRepository } from '../ports/outbound/IPendingEverifyRepository';
import { PendingEverifyItem } from '../domain/entities/PendingEverifyItem';

export class FetchSingleEverifyItemUseCase {
  constructor(
    private readonly pendingEverifyRepository: IPendingEverifyRepository
  ) { }

  async execute(
    everifyCaseQueueId: string,
  ): Promise<PendingEverifyItem> {
    return this.pendingEverifyRepository.fetchSingleEverifyItemByQueueId(
      everifyCaseQueueId
    );
  }
}
